module.exports = __webpack_public_path__ + "img/Close.843ad3ee.svg";